import React from "react";
import SelectOptionsPortal from "../../molecules/SelectOptionsPortal";
const SelectOptionsFrame = ({ children, menuPortalTarget, selectControlRef, optionLength, }) => {
    if (menuPortalTarget) {
        return (React.createElement(SelectOptionsPortal, { menuPortalTarget: menuPortalTarget, selectControlRef: selectControlRef, optionLength: optionLength }, children));
    }
    else {
        return React.createElement(React.Fragment, null, children);
    }
};
export default SelectOptionsFrame;
